import { render, staticRenderFns } from "./CardReaderAdd.vue?vue&type=template&id=90a50746"
import script from "./CardReaderAdd.vue?vue&type=script&lang=ts"
export * from "./CardReaderAdd.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports